import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchSituations = createAction('situations/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedSituations = createAction('situations/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchedSituations,
  fetchSituations,
};
